<template>
  <div class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog" style="width: 900px;">
      <div class="modal-content invent-insurance">
        <div class="modal-header">
          <a @click="$emit('close')" class="close">
            <i class="icon-close"></i>
          </a>
          <div class="col-9 pl-0">
            <h3 class="modal-title">
              {{insuranceName}}<span>({{prodId}})</span>
              <a class="text-orange" target="_blank" :href="mainPolicyInfo.URL" style="text-decoration:none">
                <i class="icon-open_as i-20"></i>
              </a>
            </h3> 
          </div>
          <div class="col-3 pr-0 text-right">
            <h4 class="my-1">#{{no}}</h4>
          </div>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <div class="radio radio-inline">
              <input type="radio" name="invent-insurance-content" id="invent-insure-radio-1" v-model="insuranceContent" value="0">
              <label for="invent-insure-radio-1">基本資料</label>
            </div>
            <div class="radio radio-inline">
              <input type="radio" name="invent-insurance-content" id="invent-insure-radio-2" v-model="insuranceContent" value="1">
              <label for="invent-insure-radio-2">附約明細</label>
            </div>
            <div class="radio radio-inline">
              <input type="radio" name="invent-insurance-content" id="invent-insure-radio-3" v-model="insuranceContent" value="2">
              <label for="invent-insure-radio-3">繳費訊息</label>
            </div>
            <div class="radio radio-inline">
              <input type="radio" name="invent-insurance-content" id="invent-insure-radio-4" v-model="insuranceContent" value="3">
              <label for="invent-insure-radio-4">保全給付</label>
            </div>
            <div class="radio radio-inline">
              <input type="radio" name="invent-insurance-content" id="invent-insure-radio-7" v-model="insuranceContent" value="6">
              <label for="invent-insure-radio-7">受益人明細</label>
            </div>
            <div class="radio radio-inline">
              <input type="radio" name="invent-insurance-content" id="invent-insure-radio-5" v-model="insuranceContent" value="4">
              <label for="invent-insure-radio-5">投資績效</label>
            </div>
            <div class="radio radio-inline">
              <input type="radio" name="invent-insurance-content" id="invent-insure-radio-6" v-model="insuranceContent" value="5">
              <label for="invent-insure-radio-6">投資約定</label>
            </div>
            <div class="radio radio-inline" v-show="isLoading_8">
               <span class="loading-block">
                 <label class="loading-text">外溢保單資訊查詢中，請稍後</label>
               </span>
            </div>
            <div class="radio radio-inline" v-show="is_show_spilloverPolicy">
              <input type="radio" name="invent-insurance-content" id="invent-insure-radio-8" v-model="insuranceContent" value="7">
              <label for="invent-insure-radio-8">外溢保單</label>
            </div>
          </div>
          <div v-if="insuranceContent==0"
          :class="{
            'section-loading': isLoading_1
          }">
            <table class="table table-basic">
              <tbody>
                <tr>
                  <th>主約效力</th>
                  <td>{{mainPolicyInfo.EFT_CODE_NM}}</td>
                  <th>投保日期</th>
                  <td>{{mainPolicyInfo.ISSUE_DATE || '— —'}}</td>
                  <th>投保年齡</th>
                  <td>{{mainPolicyInfo.AGE}}</td>
                </tr>
                <tr>
                  <th>被保人</th>
                  <td>{{mainPolicyInfo.INSD_NM}}</td>
                  <th>被保人身分證字號</th>
                  <td>{{mainPolicyInfo.INSD_ID}}</td>
                  <th>被保人生日</th>
                  <td>{{mainPolicyInfo.INSD_BRDY || '— —'}}</td>
                </tr>
                <tr>
                  <th>要保人</th>
                  <td>{{mainPolicyInfo.APC_NM}}</td>
                  <th>要保人身分證字號</th>
                  <td>{{mainPolicyInfo.APC_ID}}</td>
                  <th>要保人生日</th>
                  <td>{{mainPolicyInfo.APC_BRDY || '— —'}}</td>
                </tr>
                <tr>
                  <th>招攬單位</th>
                  <td>{{mainPolicyInfo.ACT_DIV_NO}}</td>
                  <th>墊繳表示</th>
                  <td>{{mainPolicyInfo.AUTO_PREM_CODE_CH}}</td>
                  <th>紅利選擇</th>
                  <td>{{mainPolicyInfo.DVD_KIND_CH}}</td>
                </tr>
                <tr>
                  <th>收費代號</th>
                  <td>{{mainPolicyInfo.CLC_NO || ''}}</td>
                  <th>集彙件</th>
                  <td>{{formatIS_GROUP}}</td>
                  <th>體檢</th>
                  <td>{{mainPolicyInfo.MED_EXAM_CH}}</td>
                </tr>
                <tr>
                  <th>最近異動日</th>
                  <td>{{formatLST_CHG_DATE}}</td>
                  <th>最近異動種類</th>
                  <td colspan="3">{{mainPolicyInfo.LST_CHG_KIND_CH}}</td>
                </tr>
                <tr>
                  <th>收費電話</th>
                  <td>{{mainPolicyInfo.MOBILE_TEL}}</td>
                  <th>收費地址</th>
                  <td colspan="3">{{mainPolicyInfo.ZIP_CODE}}{{mainPolicyInfo.ADDR}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-if="insuranceContent==1"
          :class="{
                'section-loading': isLoading_2
          }">
            <table class="table insurance-green">
              <thead>
                <tr>
                  <th class="text-left">被保險人</th>
                  <th class="text-left">險種名稱/險種代號</th>
                  <th>契約效力</th>
                  <th class="text-right">保額/計畫</th>
                  <th class="text-right">表訂保費</th>
                  <th>保障終止日</th>
                </tr>
              </thead>
              <tbody v-if="insurDetailList.length">
                <tr
                v-for="(insurance, index) in insurDetailList"
                :key="`insurDetail-list-${index}`"
                >
                  <td>{{insurance.cs_name}}</td>
                  <td>
                    <a class="text-orange float-right" target="_blank" 
                    :href="insurance.product_link"
                    style="text-decoration:none">
                      <i class="icon-open_as i-18"></i>
                    </a>
                    {{insurance.rd_name}}({{insurance.rd_id}}) <div v-if="insurance.job_cat_ch">職業類別：{{insurance.job_cat_ch}}</div>
                  </td>
                  <td>{{insurance.eft_code_ch}}</td>
                  <td class="text-right">{{insurance.rd_amt | numberFormat}}{{insurance.rdAmtUnit}}</td>
                  <td class="text-right">{{insurance.rd_prem | numberFormat}}{{insurance.rd_prem_unit}}</td>
                  <td v-if="insurance.term_date && insurance.term_date.indexOf('-') > -1">{{insurance.term_date | dateFormat}}</td>
                  <td v-else>{{insurance.term_date | dateFormat}}</td>
                </tr>
                
              </tbody>
              <tbody v-else>
                <tr>
                  <td class="text-center" colspan="6">
                    <h3 class="mb-3">無附加附約</h3>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-if="insuranceContent==2" :class="{
                'section-loading': isLoading_3
          }">
            <table class="table table-basic">
              <tr>
                <th>繳別</th>
                <td>{{this.PaymentDetail.PAY_FREQ}}</td>
                <th>繳費年期</th>
                <td>{{this.PaymentDetail.PAY_PRD}}</td>
                <th>已繳次數</th>
                <td>{{this.PaymentDetail.PAY_TIMES}}次</td>
              </tr>
              <tr>
                <th>主約表訂保費</th>
                <td>{{this.PaymentDetail.CURR}}{{Number(this.PaymentDetail.MAIN_PREM) | numberFormat}}</td>
                <th>主約高保費折減</th>
                <td>{{this.PaymentDetail.RATE_DISC_H}}%</td>
                <th>主約轉帳折扣</th>
                <td>{{this.PaymentDetail.RATE_DISC_W}}%</td>
              </tr>
              <tr>
                <th>附約表訂保費</th>
                <td>{{this.PaymentDetail.CURR}}{{Number(this.PaymentDetail.PREM_RD) | numberFormat}}</td>
                <th>優待保費</th>
                <td v-if="Number(this.PaymentDetail.PREM_DISC) == 0">0</td>
                <td v-else>{{this.PaymentDetail.CURR}}{{Number(this.PaymentDetail.PREM_DISC) | numberFormat}}</td>
                <th>調整保費</th>
                <td v-if="Number(this.PaymentDetail.PREM_ADJ) == 0">0</td>
                <td v-else>{{this.PaymentDetail.CURR}}{{Number(this.PaymentDetail.PREM_ADJ) | numberFormat}}</td>
              </tr>
              <tr>
                <th>下次應繳保費</th>
                <td>{{this.PaymentDetail.CURR}}{{Number(this.PaymentDetail.PREM_RCPT) | numberFormat}}</td>
                <th>下次繳費日</th>
                <td>{{this.PaymentDetail.NXT_PAY_DATE | dateFormat}}</td>
                <th>墊繳狀態</th>
                <td v-if="Number(this.PaymentDetail.AUTO_PREM_STS) == 1"><span class="text-orange">墊繳中</span></td>
                <td v-else>無</td>
              </tr>
              <tr>
                <th>繳費方式</th>
                <td>{{this.PaymentDetail.PAY_WAY_CODE}}</td>
                <th>銀行名稱</th>
                <td>{{this.PaymentDetail.BANK_NAME}}</td>
                <th>帳/卡號(末四碼)</th>
                <td>{{this.PaymentDetail.ACNT_CARD_NO}}</td>
              </tr>
            </table>

            <h4>近6次繳費記錄</h4>
            <table class="table insurance-green">
              <thead>
                <tr>
                  <th>繳費方式</th>
                  <th>帳/卡號(末四碼)</th>
                  <th class="text-right">繳費金額</th>
                  <th class="text-right">繳次</th>
                  <th class="text-left">繳費日期</th>
                  <th>備註</th>
                </tr>
              </thead>
              <tbody v-if="PaymentRecord.length">
                <tr v-for="(PR, index) in PaymentRecord"
                :key="`insurDetail-list-${index}`">
                  <td>{{PR.PAY_WAY_CODE}}</td>
                  <td v-if="PR.PAY_WAY_CODE && PR.PAY_WAY_CODE.trim() === '轉帳'">{{PR.ACNT_NO_TRN}}</td>
                  <td v-else-if="PR.PAY_WAY_CODE && PR.PAY_WAY_CODE.trim() === '信用卡'">{{PR.CARD_NO}}</td>
                  <td v-else>繳費方式非轉帳與信用卡</td>
                  <td class="text-right">{{Number(PR.TOT_PREM) | numberFormat}}元</td>
                  <td class="text-right">{{PR.PAY_TIMES}}</td>
                  <td>{{PR.PAY_DATE_CLC}}</td>
                  <td>{{PR.NOTE}}</td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td class="text-center" colspan="6">
                    <h3 class="mb-3">查無資料</h3>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-if="insuranceContent==3">
            <h4>保單一指通資訊 :</h4>
            <div :class="{
              'section-loading': isLoading_4
            }">
              <table class="table insurance-green">
                <thead>
                  <tr>
                    <th style="width:15%">受款人姓名</th>
                    <th style="width:15%">受款人角色</th>
                    <th style="width:15%">給付種類</th>
                    <th>行庫簡稱</th>
                    <th style="width:15%">帳號末四碼</th>
                    <th style="width:15%">備註</th>
                  </tr>
                </thead>
                <tbody v-if="oneInfoList.length">
                  <tr v-for="(oneInfo, index) in oneInfoList"
                  :key="`oneInfo-list-${index}`"
                  >
                    <td>{{oneInfo.bene_name}}</td>
                    <td>{{oneInfo.bene_role}}</td>
                    <td>{{oneInfo.bene_type}}</td>
                    <td>{{oneInfo.bank_simple_name}}</td>
                    <td>{{oneInfo.acnt_no_last4}}</td>
                    <td>{{oneInfo.memo}}</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td class="text-center" colspan="6">
                      <h3 class="mb-3">未約定</h3>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <h4>近6次給付記錄</h4>
            <div :class="{
              'section-loading': isLoading_4
            }">
              <table class="table insurance-green">
                <thead>
                  <tr>
                    <th>給付方式</th>
                    <th>轉帳帳號(末四碼)</th>
                    <th>給付項目</th>
                    <th class="text-right">給付金額</th>
                    <th>給付日期</th>
                    <th>備註</th>
                  </tr>
                </thead>
                <tbody v-if="payRecordsList.length">
                  <tr v-for="(payRecord, index) in payRecordsList"
                  :key="`payRecords-list-${index}`"
                  >
                    <td>{{payRecord.PAY_KIND_CH}}</td>
                    <td>{{payRecord.ACPT_ACNT_NO}}</td>
                    <td>{{payRecord.TRN_KIND_CH}}</td>
                    <td class="text-right">{{Number(payRecord.RTN_ADD_AMT) | numberFormat}}元</td>
                    <td>{{payRecord.ACNT_DATE | dateFormat}}</td>
                    <td>{{payRecord.NOTE}}</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td class="text-center" colspan="6">
                      <h3 class="mb-3">無給付紀錄</h3>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div v-if="insuranceContent==4"
          :class="{
            'section-loading': isLoading_6
          }">
            <table class="table table-basic" v-if="investmentPerformance.dngrpolind != '1'">
              <tr>
                <th>保單帳戶價值 (A)</th>
                <td>{{investmentPerformance.pol_acc_val || '— —'}}元</td>
                <th rowspan="2">
                  投資損益金額<br/>( A+B+C+F ) - ( D-E )
                </th>
                <td rowspan="2">{{investmentPerformance.investprofit}}元</td>
              </tr>
              <tr>
                <th>累計提領金額 (B)</th>
                <td>{{investmentPerformance.cryamtwithoutfee || '— —'}}元</td>
              </tr>
              <tr>
                <th>累計現金配息或撥回資產 (C)</th>
                <td>{{investmentPerformance.bou_div_l || '— —'}}元</td>
                <th rowspan="2">
                  參考總投資報酬率<br/>( A+B+C+F ) / ( D-E ) -1
                </th>
                <td rowspan="2">{{investmentPerformance.returnofinvestment}}%</td>
              </tr>
              <tr>
                <th>總繳保險費 (D)</th>
                <td>{{investmentPerformance.sum_pay_prem || '— —'}}元</td>
              </tr>
              <tr>
                <th>累計保費費用 (E)</th>
                <td>{{investmentPerformance.sum_prem_fee || '— —'}}元</td>
                <th rowspan="2">
                  參考總保費保酬率<br/>( A+B+C ) / D -1
                </th>
                <td rowspan="2">{{investmentPerformance.returnofpremium}}%</td>
              </tr>
              <tr>
                <th>總收取費用 (F)</th>
                <td>{{investmentPerformance.sum_tot_fee || '— —'}}元</td>
              </tr>
            </table>
            <table class="table table-basic" v-else>
              <tr>
                <th>保單帳戶價值 (A)</th>
                <td>{{investmentPerformance.pol_acc_val || '— —'}}元</td>
                <th rowspan="2">
                  投資損益金額<br/>( A+B+C+G ) - ( D-E-F )
                </th>
                <td rowspan="2">{{investmentPerformance.investprofit || '— —'}}元</td>
              </tr>
              <tr>
                <th>累計提領金額 (B)</th>
                <td>{{investmentPerformance.cryamtwithoutfee || '— —'}}元</td>
              </tr>
              <tr>
                <th>累計現金配息或撥回資產 (C)</th>
                <td>{{investmentPerformance.bou_div_l || '— —'}}元</td>
                <th rowspan="2">
                  參考總投資報酬率<br/>( A+B+C+G ) / ( D-E-F ) -1
                </th>
                <td rowspan="2">{{investmentPerformance.returnofinvestment}}%</td>
              </tr>
              <tr>
                <th>總繳保險費 (D)</th>
                <td>{{investmentPerformance.sum_pay_prem || '— —'}}元</td>
              </tr>
              <tr>
                <th>累計保費費用 (E)</th>
                <td>{{investmentPerformance.sum_prem_fee || '— —'}}元</td>
                <th rowspan="3">
                  參考總保費保酬率<br/>( A+B+C ) / D -1
                </th>
                <td rowspan="3">{{investmentPerformance.returnofpremium}}%</td>
              </tr>
              <tr>
                <th>定期壽險保險成本 (F)</th>
                <td>{{investmentPerformance.sum_risk_prem || '— —'}}元</td>
              </tr>
              <tr>
                <th>總收取費用 (G)</th>
                <td>{{investmentPerformance.sum_tot_fee || '— —'}}元</td>
              </tr>
            </table>
            <h4>持有標的明細</h4>
            <table class="table table-basic insurance-green">
              <thead>
                <tr>
                  <th class="text-center" rowspan="2">序號</th>
                  <th width="50" class="text-center" rowspan="2">標的<br/>代碼</th>
                  <th width="50" class="text-center" rowspan="2">標的<br/>名稱</th>
                  <th width="50" class="text-center" rowspan="2">標的<br/>型態</th>
                  <th width="50" class="text-center" rowspan="2">標的<br/>幣別</th>
                  <th class="text-center" rowspan="2">持有單位數</th>
                  <th width="100" class="text-center"><small>平均淨值</small></th>
                  <th width="100" class="text-center"><small>平均匯率</small></th>
                  <th class="text-center" rowspan="2">市值<br/>({{this.targetsCurr}})</th>
                  <th class="text-center" rowspan="2">持有成本<br/>({{this.targetsCurr}})</th>
                  <th class="text-center" rowspan="2">損益金額<br/>({{this.targetsCurr}})</th>
                  <th class="text-center" rowspan="2">標的<br/>報酬率</th>
                </tr>
                <tr>
                  <th class="text-center"><small>淨值(日期)</small></th>
                  <th class="text-center"><small>匯率(日期)</small></th>
                </tr>
              </thead>
              <tbody
              v-for="(target, i) in investmentTargets"
              :key="`investment-targets-${i}`">
                <tr>
                  <td class="text-center" rowspan="2">{{i+1}}</td>
                  <td class="text-center" rowspan="2">{{target.fund_id}}</td>
                  <td rowspan="2">{{target.fund_c_name}}</td>
                  <td class="text-center" rowspan="2">{{target.fund_class || '— —'}}</td>
                  <td class="text-center" rowspan="2">{{target.curr_c}}</td>
                  <td class="text-center" rowspan="2">{{target.hold_unit}}</td>
                  <td class="text-center"><small>{{target.avg_bid_price}}</small></td>
                  <td class="text-center"><small>{{target.avg_exch_rate}}</small></td>
                  <td rowspan="2" class="text-right">{{target.hold_val_l || '— —'}}</td>
                  <td rowspan="2" class="text-right">{{target.cost || '— —'}}</td>
                  <td rowspan="2" class="text-right">{{target.reward_mny || '— —'}}</td>
                  <td rowspan="2" class="text-right">{{target.remuneration}}%</td>
                </tr>
                <tr>
                  <td class="text-center">
                    <small>
                      {{target.bid_price}}<br/>({{target.bid_date || '— —'}})
                    </small>
                  </td>
                  <td class="text-center">
                    <small>
                      {{target.exch_rate}}<br/>({{target.exch_rate_date || '— —'}})
                    </small>
                  </td>
                </tr>
              </tbody>
            </table>
            <h4 v-if="showItem">近3個月收益分配或撥回資產紀錄</h4>
            <div v-if="limitedInterestDatas.length > 0">
              <table class="table insurance-green">
                <thead>
                  <tr>
                    <th class="text-center">序號</th>
                    <th class="text-center">收益實際確認日</th>
                    <th class="text-center">匯款日期</th>
                    <th class="text-center">給付金額({{this.targetsCurr}})</th>
                    <th class="text-center">給付方式</th>
                    <th class="text-center">給付狀態</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                  v-for="(interest, i) in limitedInterestDatas"
                  :key="`investment-interest-${i}`">
                    <td class="text-center">{{i+1}}</td>
                    <td class="text-center">{{interest.bou_date || '— —'}}</td>
                    <td class="text-center">{{interest.rmt_sts_date || '— —'}}</td>
                    <td class="text-right">{{interest.sum_bou_div_l || '— —'}}</td>
                    <td class="text-center">{{interest.real_bou_kind}}</td>
                    <td class="text-center">{{interest.bou_sts}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="text-center pb-4" v-if="showItem && limitedInterestDatas.length == 0">
              <h4>尚無紀錄</h4>
            </div>
            
            <div class="action text-right" >
              <a role="button" class="btn btn-default" :href="this.InventUrl" target="_blank">
                歷年紀錄查詢<br><br>
              </a>
              <a role="button" class="btn btn-primary" @click="createPDF()" :disabled="printButtonDisabled">
                {{this.printButtonName}}<br><br>
              </a>
              <a v-if="this.ILPStatementUrl" role="button" class="btn btn-primary" :href="this.ILPStatementUrl" target="_blank">
                下載最新一期對帳單<br>（密碼為要保人身分證字號）
              </a>
            </div>
          </div>
          <div v-if="insuranceContent==5" :class="{'section-loading': isLoading_7}">
            <div class="table-group" v-if="showInvestmentAgreement.record1Data0 || showInvestmentAgreement.record1Data1 || showInvestmentAgreement.record1Data6">
              <table class="table insurance-green">
                <thead>
                  <tr v-if="showInvestmentAgreement.record1Data0 || showInvestmentAgreement.record1Data6">
                    <th colspan="2" width="200" class="text-center">續期基金配置約定</th>
                    <td colspan="3">生效日期：{{this.record1Data0KeyDate || this.record1Data6KeyDate || '— —'}}</td>
                  </tr>
                  <tr v-if="showInvestmentAgreement.record1Data1">
                    <th colspan="2" width="200" class="text-center">母基金配置約定</th>
                    <td colspan="3">生效日期：{{this.record1Data1KeyDate || '— —'}}</td>
                  </tr>
                  <tr>
                    <th class="text-center">序號</th>
                    <th width="120" class="text-center">標的代號</th>
                    <th class="text-center">標的名稱</th>
                    <th class="text-center">標的幣別</th>
                    <th class="text-center">投資比例</th>
                  </tr>
                </thead>
                <tbody v-if="showInvestmentAgreement.record1Data1">
                  <tr v-for="(item, i) in record1Data1"
                  :key="`record1-Data1-${i}`">
                    <td class="text-center">{{i+1}}</td>
                    <td class="text-center">{{item.FUND_ID}}</td>
                    <td>{{item.FUND_C_NAME}}</td>
                    <td class="text-center">{{item.FUND_CURR_NAME}}</td>
                    <td class="text-center">{{item.INV_RATE}}</td>
                  </tr>
                </tbody>
                <tbody v-if="showInvestmentAgreement.record1Data0">
                  <tr v-for="(item, i) in record1Data0"
                  :key="`record1-Data1-${i}`">
                    <td class="text-center">{{i+1}}</td>
                    <td class="text-center">{{item.FUND_ID}}</td>
                    <td>{{item.FUND_C_NAME}}</td>
                    <td class="text-center">{{item.FUND_CURR_NAME}}</td>
                    <td class="text-center">{{item.INV_RATE}}</td>
                  </tr>
                </tbody>
                <tbody v-if="showInvestmentAgreement.record1Data6">
                  <tr v-for="(item, i) in record1Data6"
                  :key="`record1-Data1-${i}`">
                    <td class="text-center">{{i+1}}</td>
                    <td class="text-center">{{item.FUND_ID}}</td>
                    <td>{{item.FUND_C_NAME}}</td>
                    <td class="text-center">{{item.FUND_CURR_NAME}}</td>
                    <td class="text-center">{{item.INV_RATE}}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="table-group" v-if="showInvestmentAgreement.record1Data2">
              <table class="table insurance-green">
                <thead>
                  <tr>
                    <th colspan="2" width="200" class="text-center">子基金配置及加碼約定</th>
                    <td colspan="4">生效日期：{{this.record1Data2KeyDate || '— —'}}</td>
                  </tr>
                  <tr>
                    <th class="text-center">序號</th>
                    <th width="120" class="text-center">標的代號</th>
                    <th class="text-center">標的名稱</th>
                    <th class="text-center">標的幣別</th>
                    <th class="text-center">投資比例</th>
                    <th class="text-center">加碼倍數</th>
                  </tr>
                </thead>
                <tbody>
                  <tr 
                    v-for="(item, i) in record1Data2"
                    :key="`record1-Data2-${i}`">
                    <td class="text-center">{{i+1}}</td>
                    <td class="text-center">{{item.FUND_ID}}</td>
                    <td>{{item.FUND_C_NAME}}</td>
                    <td class="text-center">{{item.FUND_CURR_NAME}}</td>
                    <td class="text-center">{{item.INV_RATE}}</td>
                    <td class="text-center">{{item.ADD_RATIO}}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="table-group" v-if="showInvestmentAgreement.record1Data3">
              <table class="table table-basic">
                <tr>
                  <th width="200" class="text-center"> 自動轉換金額約定</th>
                  <td widht="50%">生效日期：{{this.record1Data3KeyDate || '— —'}}</td>
                  <th width="200" class="text-center">約定金額({{this.targetsCurr}})</th>
                  <td widht="50%">{{this.record1Data3AFT_AMT}}</td>
                </tr>
              </table>
            </div>

            <div class="table-group" v-if="showStopSetting">
              <table class="table insurance-green">
                <thead>
                  <tr>
                    <th colspan="2" width="200" class="text-center">停利設定</th>
                    <td colspan="3">生效日期：{{this.profitSettingsKeyDate || '— —'}}</td>
                  </tr>
                  <tr>
                    <th class="text-center">序號</th>
                    <th width="120" class="text-center">標的代號</th>
                    <th class="text-center">標的名稱</th>
                    <th class="text-center">標的幣別</th>
                    <th class="text-center">停利點</th>
                  </tr>
                </thead>
                <tbody v-if="profitSettingsData.length > 0">
                  <tr 
                  v-for="(item, i) in profitSettingsData"
                  :key="`profitSettings-Data-${i}`">
                    <td class="text-center">{{i+1}}</td>
                    <td class="text-center">{{item.FUND_ID}}</td>
                    <td>{{item.FUND_C_NAME}}</td>
                    <td class="text-center">{{item.FUND_CURR_NAME}}</td>
                    <td class="text-center">{{item.PRFT_PT}}%</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="5" class="text-center">
                      <h3 >【無停利設定】</h3>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="table-group" v-if="showInvestmentAgreement.record1Data5">
              <table class="table table-basic">
                <tr>
                  <th width="200" class="text-center">收益分配或撥回資產分配</th>
                  <td widht="50%">生效日期：{{this.record1Data5KeyDate || '— —'}}</td>
                  <th width="200" class="text-center">約定方式</th>
                  <td widht="50%">{{this.record1Data5AFT_BOU_TYPE_OPT_C}}</td>
                </tr>
              </table>
            </div>

            <div class="table-group" v-if="showInvestmentAgreement.record1Data7">
              <table class="table table-basic">
                <tr>
                  <th width="260" class="text-center">再投資平台投資標的配置比例</th>
                  <td>生效日期：{{this.record1Data7KeyDate || '— —'}}</td>
                </tr>
              </table>
              <table class="table insurance-green">
                <thead>
                  <tr>
                    <th class="text-center">序號</th>
                    <th class="text-center">標的代號</th>
                    <th class="text-center">標的名稱</th>
                    <th class="text-center">標的幣別</th>
                    <th class="text-center">投資比例</th>
                  </tr>
                </thead>
                <tbody>
                  <tr 
                  v-for="(item, i) in record1Data7"
                  :key="`record1-Data7-${i}`">
                    <td class="text-center">{{i+1}}</td>
                    <td class="text-center">{{item.FUND_ID}}</td>
                    <td>{{item.FUND_C_NAME}}</td>
                    <td class="text-center">{{item.FUND_CURR_NAME}}</td>
                    <td class="text-center">{{item.INV_RATE}}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="table-group" v-if="showInvestmentAgreement.record1Data8">
              <table class="table table-basic">
                <tr>
                  <th width="220" class="text-center">約定之回流標的</th>
                  <td>生效日期：{{this.record1Data8KeyDate || '— —'}}</td>
                </tr>
              </table>
              <table class="table insurance-green">
                <thead>
                  <tr>
                    <th class="text-center">標的代號</th>
                    <th class="text-center">標的名稱</th>
                  </tr>
                </thead>
                <tbody>
                  <tr 
                  v-for="(item, i) in record1Data8"
                  :key="`record1-Data8-${i}`">
                    <td class="text-center">{{item.FUND_ID}}</td>
                    <td>{{item.FUND_C_NAME}}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="table-group" v-if="showInvestmentAgreement.record1Data9">
              <table class="table insurance-green">
                <thead>
                  <tr v-if="showInvestmentAgreement.record1Data9">
                    <th colspan="2" width="200" class="text-center">投資收益給付方式</th>
                    <td colspan="3">生效日期：{{this.record1Data9KeyDate || '— —'}}</td>
                  </tr>
                  <tr>
                    <th class="text-center">序號</th>
                    <th width="120" class="text-center">標的代號</th>
                    <th width="210" class="text-center">標的名稱</th>
                    <th width="100" class="text-center">標的幣別</th>
                    <th width="210" class="text-center">投資收益約定給付方式</th>
                  </tr>
                </thead>
                <tbody v-if="showInvestmentAgreement.record1Data9">
                  <tr v-for="(item, i) in record1Data9"
                  :key="`record1-Data1-${i}`">
                    <td class="text-center">{{i+1}}</td>
                    <td class="text-center">{{item.FUND_ID}}</td>
                    <td>{{item.FUND_C_NAME}}</td>
                    <td class="text-center">{{item.FUND_CURR_NAME}}</td>
                    <td class="text-center">{{item.KIND_NAME}}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="table-group" v-if="showInvestmentAgreement.record1Data10">
              <table class="table table-basic">
                <tr>
                  <th width="260" class="text-center">收益投資機制投資標的配置比例</th>
                  <td>生效日期：{{this.record1Data10KeyDate || '— —'}}</td>
                </tr>
              </table>
              <table class="table insurance-green">
                <thead>
                  <tr>
                    <th class="text-center">序號</th>
                    <th class="text-center">標的代號</th>
                    <th class="text-center">標的名稱</th>
                    <th class="text-center">標的幣別</th>
                    <th class="text-center">投資比例</th>
                  </tr>
                </thead>
                <tbody>
                  <tr 
                  v-for="(item, i) in record1Data10"
                  :key="`record1-Data7-${i}`">
                    <td class="text-center">{{i+1}}</td>
                    <td class="text-center">{{item.FUND_ID}}</td>
                    <td>{{item.FUND_C_NAME}}</td>
                    <td class="text-center">{{item.FUND_CURR_NAME}}</td>
                    <td class="text-center">{{item.INV_RATE}}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="action text-right">
              <a role="button" class="btn btn-default" :href="this.InventUrl" target="_blank">
                歷年紀錄查詢
              </a>
              <a role="button" class="btn btn-primary" 
                href="https://fund.cathaylife.com.tw/content.html?sUrl=$W$HTML$SELECT]DJHTM" target="_blank">
                可鏈結標的
              </a>
            </div>
          </div>
          <div v-if="insuranceContent==6" 
          :class="{
            'section-loading': isLoading_5
          }">
            <div class="table-group">
              <table class="table insurance-green">
                <thead>
                  <tr>
                    <th>險種名稱/險種代號</th>
                    <th>類別</th>
                    <th>受益人姓名</th>
                    <th>關係</th>
                    <th class="text-right">受益比例</th>
                    <th>順位</th>
                  </tr>
                </thead>
                <tbody v-if="beneficiariesList.length">
                  <tr v-for="(item, i) in beneficiariesList"
                  :key="`record1-Data8-${i}`">
                    <td>{{item.prod_id_ch}}({{item.prod_id}})</td>
                    <td>{{item.bene_type_ch}}</td>
                    <td>{{item.bene_name}}</td>
                    <td>{{item.rltn_ch}}</td>
                    <td class="text-right">{{item.bene_rato}}</td>
                    <td>{{item.bene_prio}}</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td class="text-center" colspan="6">
                      <h3 class="mb-3">無受益人明細</h3>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!--外溢保單block-->
          <div v-if="insuranceContent==7">
            <span v-if="is_show_spilloverPolicy && !is_show_spilloverPolicy_under18 && !is_show_spilloverPolicy_under21" class="span-prod-hint-block">外溢保單相關回饋為保戶權益，請務必向保戶說明各商品之外溢機制，並提醒保戶(被保險人)於指定期間完成回饋條件，以確保客戶權益。</span>
            <span v-else-if="is_show_spilloverPolicy_under18" class="span-prod-hint-block">本商品被保險人保險年齡18歲(含)以上，始啟動本商品之健康促進相關回饋，即未滿18歲尚未啟動外溢機制，詳請參考保單契約條款。</span>
            <span v-else-if="is_show_spilloverPolicy_under21" class="span-prod-hint-block">本商品被保險人保險年齡21歲(含)以上，始啟動本商品之健康促進相關回饋，即未滿21歲尚未啟動外溢機制，詳請參考保單契約條款。</span>
              <div v-for="(item, index) in spilloverPolicyList" :key="`div-spillover-policy-${index}`" class="div-spillover-policy">
                <div v-if="item.is_spillover_prod == 'Y' && item.is_show">
                  <br>
                  <span class="span-prod-name-block">{{item.prod_name}}({{item.prod_id}})
                    <a class="text-orange product-hyper-link" target="_blank" :href="item.link_url">
                      <i class="icon-open_as i-20"></i>
                    </a>
                  </span>
                  <br>
                  <span class="span-insd-name-block">被保險人 : {{item.insd_name}}</span>
                  <span v-if="item.is_investment == 'Y'">
                    <br>{{item.feedback_message}}
                  </span>
                  <span v-else-if="item.is_membership == 'Y'" class="span-spillover-start-term-date">
                    次年度外溢回饋判斷日 : {{item.spillover_memstl_date | dateFormat}}
                  </span>
                  <span v-else-if="item.spillover_start_date && item.spillover_term_date" class="span-spillover-start-term-date">
                    外溢回饋計算期間 : {{item.spillover_start_date | dateFormat}} ~ {{item.spillover_term_date | dateFormat}}
                  </span>
                  <!--折減型-->
                  <table v-if="item.is_premium_reduce=='Y'" class="table table-basic">
                    <thead>
                      <tr>
                        <th class="text-left" width="15%">外溢項目</th>
                        <th class="text-left" width="35%">達成狀況</th>
                        <th class="text-left" width="23%">次年度保費回饋%數</th>
                        <th class="text-left" width="27%">備註</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>健走步數</td>
                        <td>{{item.spillover_achieve_times | getAchieveTimes}}</td>
                        <td>{{item.spillover_disc_rate | getPercentNumber}}</td>
                        <td>{{item.is_cwp_member | getCwpText}}</td>
                      </tr>
                      <tr v-if="item.is_health_check == 'Y'">
                        <td>健康檢查</td>
                        <td>{{item.health_check_doc | getUploadStatusText}}</td>
                        <td>{{item.health_check_disc_rate | getPercentNumber}}</td>
                        <td>上傳日: {{item.health_check_update | dateFormat}}</td>
                      </tr>
                      <tr v-if="item.is_cancer_scerrn == 'Y'">
                        <td>癌症篩檢</td>
                        <td v-if="item.is_vaccine == 'Y' && item.is_smoking_cessation == 'Y'" rowspan="3">
                          {{item.spilloverall_doc | getUploadStatusText}}
                        </td>
                        <td v-else-if="item.is_vaccine == 'Y'" colspan="2">
                          {{item.spilloverall_doc | getUploadStatusText}}
                        </td>
                        <td v-if="item.is_vaccine == 'Y' && item.is_smoking_cessation == 'Y'" rowspan="3">
                          {{item.spilloverall_disc_rate | getPercentNumber}}
                        </td>
                        <td v-else-if="item.is_vaccine == 'Y'" colspan="2">
                          {{item.spilloverall_disc_rate | getPercentNumber}}
                        </td>
                        <td v-if="item.is_vaccine == 'Y' && item.is_smoking_cessation == 'Y'" rowspan="3">
                          上傳日: {{item.spilloverall_update | dateFormat}}
                        </td>
                        <td v-else-if="item.is_vaccine == 'Y'" colspan="2">
                          上傳日: {{item.spilloverall_update | dateFormat}}
                        </td>
                      </tr>
                      <tr v-if="item.is_vaccine == 'Y'">
                        <td>疫苗接種</td>
                      </tr>
                      <tr v-if="item.is_smoking_cessation == 'Y'">
                        <td>戒菸治療</td>
                      </tr>
                    </tbody>
                  </table>
                  <!--增額型-->
                  <table v-else-if="item.is_increase_amt=='Y'" class="table table-basic">
                    <thead>
                      <tr>
                        <th class="text-left">外溢項目</th>
                        <th class="text-left">達成狀況</th>
                        <th class="text-left">增額回饋%數</th>
                        <th class="text-left">備註</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>健走步數</td>
                        <td>{{item.spillover_achieve_times | getAchieveTimes}}</td>
                        <td>{{item.spillover_ppo_amt | getPercentNumber}}</td>
                        <td>{{item.is_cwp_member | getCwpText}}</td>
                      </tr>
                    </tbody>
                  </table>            
                  <!--投資型-->
                  <table v-else-if="item.is_investment=='Y'" class="table table-basic">
                    <thead>
                      <tr>
                        <th class="text-left">外溢項目</th>
                        <th class="text-left">計步優惠</th>
                        <th class="text-left">備註</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>健走步數</td>
                        <td>{{item.trn_item | getTrnItemText}}</td>
                        <td>{{item.is_cwp_member | getCwpText}}</td>
                      </tr>
                    </tbody>
                  </table>
                  <!--會員型-->
                  <table v-else-if="item.is_membership=='Y'" class="table table-basic">
                    <thead>
                      <tr>
                        <th class="text-left">外溢項目</th>
                        <th class="text-left">當前CWP會員等級*</th>
                        <th class="text-left">當年度累積會員經驗分*</th>
                        <th class="text-left">次保單年度回饋預估%數*</th>
                        <th class="text-left">備註</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>CWP會員型</td>
                        <td>{{item.cwp_level | getCwpLevelText}}</td>
                        <td>{{item.cwp_exp}}</td>
                        <td>{{item.spillovermem_disc_rate | getPercentNumber}}</td>
                        <td>{{item.is_cwp_member | getCwpText}}</td>
                      </tr>
                    </tbody>
                  </table>
                  <!--其他型-->
                  <span v-else-if="item.is_premium_reduce == 'N' && item.is_increase_amt == 'N' && item.is_investment == 'N'">
                    <br>{{item.feedback_message}}
                  </span>
                  <!--會員型說明區塊-->
                  <p v-if="item.is_membership=='Y'">
                    *註：<br>
                    <table>
                      <tr>
                        <td class="td-align-top">
                          1.&nbsp;&nbsp;
                        </td>
                        <td>
                          會員年度：客戶加入CWP健康計劃之日期起算一年，以加入會員日為週期重新起算。
                        </td>
                      </tr>
                      <tr>
                        <td class="td-align-top">
                          2.&nbsp;&nbsp;
                        </td>
                        <td>
                          會員等級：客戶於會員年度間累積經驗分，達標後立即升等；本會員年度累積之會員等級，將延續至下一會員年度。(初始等級為一般會員，經驗分達6,000分升等為進階會員，達12,000分升等為菁英會員。)
                        </td>
                      </tr>
                      <tr>
                        <td class="td-align-top">
                          3.&nbsp;&nbsp;
                        </td>
                        <td>
                          經驗分：每個會員年度累積之經驗分，將於結算日隔日歸零並重新計算。
                        </td>
                      </tr>
                      <tr>
                        <td class="td-align-top">
                          4.&nbsp;&nbsp;
                        </td>
                        <td>
                          CWP會員等級/經驗分計算案例：110/7/13加入CWP，會員等級及經驗分將於每年7/12結算，經驗分於7/13歸零重新計算；111/7/12結算時若達進階會員資格，111/7/13~112/7/12 會員等級將延續為進階會員。
                        </td>
                      </tr>
                      <tr>
                        <td class="td-align-top">
                          5.&nbsp;&nbsp;
                        </td>
                        <td>
                          次年度外溢回饋判斷日(指定日期)：為保單週年月前兩個月最後一日(例: 投保始期為110/9/15，次年度外溢回饋判斷日則為111/7/31、112/7/31…以此類推)。
                        </td>
                      </tr>
                      <tr>
                        <td class="td-align-top hint-text">
                          6.&nbsp;&nbsp;
                        </td>
                        <td class="hint-text">
                          次保單年度回饋預估%數：系統以當前CWP會員等級進行預估，實際須以「次年度外溢回饋判斷日」當天之會員等級為準，核算次保單年度之保費折減%數。
                        </td>
                      </tr>
                    </table>
                  </p>
                </div>
              </div>
            </div>
          </div>          
        </div>
      </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import { commonMixin } from "@/mixins/common";
import { queryMainPolicyInfo } from "@/service"; // 主約基本資料
import { queryMinorInsurDetail } from "@/service";
import { getInsuDetailPayRecords } from "@/service";
import { queryMainPolicyBeneficiariesInfo } from "@/service";
import { queryInvestPerformance } from "@/service"; //  查詢投資績效
import { queryInvestProfit } from "@/service"; //查詢投資約定   停利設定
import { queryPaymentMessage } from "@/service";
import { getInvestPDF } from "@/service";
import { getSpilloverPolicyForBnk } from "@/service";

export default {
  name: "bkInventInsuranceModal",
  mixins: [commonMixin],
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    no: {
      type: String,
      default: "",
    },
    insuranceName: {
      type: String,
      default: "",
    },
    prodId: {
      type: String,
      default: "",
    },
    targetId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      showItem: false, //近三個月現金配息
      showStopSetting: false, //停利設定
      showInvestmentAgreement: {}, //投資約定顯示table
      isLoading_1: false,
      isLoading_2: false,
      isLoading_3: false,
      isLoading_4: false,
      isLoading_5: false,
      isLoading_6: false,
      isLoading_7: false,
      isLoading_8: false,
      printButtonDisabled: false,
      printButtonName: "",
      insuranceContent: 0,
      PDFName: "",
      roleOpt: ["配偶", "子女"],
      currentIndex: null,
      currentMember: null,
      printTarget: {},
      familyMembers: [
        {
          name: "王大進",
          role: "配偶",
          identityID: "A223456789",
          birthday: "60/03/15",
          edit: false,
        },
        {
          name: "王圈圈",
          role: "子女",
          identityID: "A223456789",
          birthday: "77/03/15",
          edit: false,
        },
        {
          name: "王叉叉",
          role: "子女",
          identityID: "A223456789",
          birthday: "80/03/15",
          edit: false,
        },
      ],
      insurDetailList: [],
      mainPolicyInfo: {},
      payRecordsList: [],
      beneficiariesList: [],
      investmentPerformance: {},
      investmentTargets: [],
      interestDatas: [],
      investmentSetting: [],
      record1Data0: [],
      record1Data1: [],
      record1Data: [],
      investdata: {},
      record1Data0KeyDate: "",
      record1Data1KeyDate: "",
      record1Data2: [],
      record1Data2KeyDate: "",
      record1Data3KeyDate: "",
      record1Data3AFT_AMT: "",
      record1Data4: [],
      record1Data4KeyDate: "",
      record1Data5: [],
      record1Data5KeyDate: "",
      record1Data5AFT_BOU_TYPE_OPT_C: "",
      record1Data6: [],
      record1Data6KeyDate: "",
      record1Data7: [],
      record1Data7KeyDate: "",
      record1Data8: [],
      record1Data8KeyDate: "",
      record1Data9: [],
      record1Data9KeyDate: "",
      record1Data10: [],
      record1Data10KeyDate: "",
      profitSettingsData: [],
      profitSettingsKeyDate: "",
      PaymentDetail: [],
      PaymentRecord: [],
      InventUrl: "",
      ILPStatementUrl: "",
      targetsCurr: "",
      oneInfoList: [],
      spilloverPolicyList: [], //外溢保單
      is_show_spilloverPolicy: false,
      is_show_spilloverPolicy_under18: false,
      is_show_spilloverPolicy_under21: false
    };
  },
  filters: {
    //CWP綁定對照
    getCwpText: function(val) {
      let text = "";
      if (!val || !val.trim()) {
        return text;
      }
      if (val == "N") {
        text = "未綁定CWP";
      }
      return text;
    },
    //上傳資料狀態對照
    getUploadStatusText: function(val) {
      let text = "";
      if (!val || !val.trim()) {
        return text;
      }
      if (val == "00") {
        text = "未上傳";
      } else if (val == "01") {
        text = "審核中";
      } else if (val == "02") {
        text = "審核未過，重新上傳";
      } else if (val == "03") {
        text = "已上傳成功";
      }
      return text;
    },
    //達成狀況對照
    getAchieveTimes: function(val) {
      let text = val;
      if (!val || !val.trim() || val.trim() == "00") {
        text = "0";
      }
      return text + "個月";
    },
    //次年度保費回饋%數對照
    getPercentNumber: function(val) {
      if (!val || !val.trim() || val.trim() == "00") {
        return "0%";
      }
      return val + "%";
    },
    //投資型交易項目對照
    getTrnItemText: function(val) {
      let text = "";
      if (!val || !val.trim()) {
        return text;
      } else if (val == "DDL") {
        text = "加值給付";
      } else if (val == "CC4") {
        text = "保險成本折減";
      } else if (val == "HDB") {
        text = "步數達標額外加值給付";
      }
      return text;
    },
    //CWP會員等級
    getCwpLevelText: function(val) {
      let text = "";
      if (!val || !val.trim()) {
        return text;
      } else if (val == "0") {
        text = "未加入CWP";
      } else if (val == "1") {
        text = "初階會員";
      } else if (val == "2") {
        text = "進階會員";
      } else if (val == "3") {
        text = "菁英會員";
      }
      return text;
    },
  },
  computed: {
    limitedInterestDatas: function() {
      return this.interestDatas;
    },
    getPrintTarget() {
      return window.$(".invent-insurance");
    },
    formatLST_CHG_DATE() {
      // 最近異動日
      if (
        !this.mainPolicyInfo.LST_CHG_DATE ||
        this.mainPolicyInfo.LST_CHG_DATE === "0/01/01"
      ) {
        return "— —";
      } else {
        return this.mainPolicyInfo.LST_CHG_DATE;
      }
    },
    formatIS_GROUP() {
      // 集彙件轉換Y=>是
      if (this.mainPolicyInfo.IS_GROUP === "Y") {
        return "是";
      } else {
        return "否";
      }
    },
  },
  watch: {
    open: "initData",
    // 難字刷新
    isLoading_1(val) {
      if (!val) {
        this.registerHanlink();
      }
    },
    isLoading_2(val) {
      if (!val) {
        this.registerHanlink();
      }
    },
    isLoading_3(val) {
      if (!val) {
        this.registerHanlink();
      }
    },
    isLoading_4(val) {
      if (!val) {
        this.registerHanlink();
      }
    },
    isLoading_5(val) {
      if (!val) {
        this.registerHanlink();
      }
    },
    isLoading_6(val) {
      if (!val) {
        this.registerHanlink();
      }
    },
    isLoading_7(val) {
      if (!val) {
        this.registerHanlink();
      }
    },
    printButtonDisabled: {
      immediate: true,
      handler(val) {
        this.printButtonName = val ? "檔案產生中..." : "開啟績效報告(PDF)";
      },
    },
    insuranceContent: function() {
      this.registerHanlink();
    },
  },
  methods: {
    ...mapActions(["setPageLock"]),
    initData(val) {
      if (val) {
        this.insuranceContent = "0";
        this.getMainPolicyInfo();
        this.getSecondaryPolicyDetail();
        this.getPayRecordsList();
        this.getBeneficiariesList();
        this.getPerformance();
        this.getPaymentMessage();
        this.PDFName = this.insuranceName;
        this.getSpilloverPolicy();
      }
    },
    getMainPolicyInfo() {
      this.isLoading_1 = true;
      queryMainPolicyInfo(this.no, this.$store.state.userInfo.id).then(
        (result) => {
          this.mainPolicyInfo = result.body;
          // console.log("查詢主約基本資料 API: "+JSON.stringify(this.mainPolicyInfo));
          if (!this.mainPolicyInfo) {
            this.mainPolicyInfo = {};
          } else {
            switch (this.mainPolicyInfo.MED_EXAM_CH) {
              case "無體":
                this.mainPolicyInfo.MED_EXAM_CH = "無體檢";
                break;
            }
          }
          this.isLoading_1 = false;
        }
      );
    },
    getSecondaryPolicyDetail() {
      this.isLoading_2 = true;
      queryMinorInsurDetail(this.$store.state.userInfo.id, this.no).then(
        (result) => {
          if (result.body.rider_list && result.body.rider_list.length > 0) {
            this.insurDetailList = result.body.rider_list.map((item) => {
              return {
                policy_no: item.POLICY_NO,
                cs_name: item.INSD_NAME,
                eft_code_ch: item.EFT_CODE_CH,
                term_date: item.TERM_DATE,
                rd_name: item.RD_NAME,
                rd_id: item.RD_ID,
                rd_prem: Number(item.RD_PREM),
                rd_prem_unit: "元",
                rd_amt: Number(item.RD_AMT),
                rdAmtUnit: item.RD_AMT_UNIT,
                curr: item.NTD,
                product_link: item.PRODUCT_LINK,
                job_cat_ch: item.JOB_CAT_CH,
              };
            });
            this.isLoading_2 = false;
          } else {
            this.insurDetailList = [];
            this.isLoading_2 = false;
          }
        }
      );
    },
    getPayRecordsList() {
      //查詢保全訊息-給付紀錄&已約定的保單一指通資訊
      this.isLoading_4 = true;
      getInsuDetailPayRecords(this.$store.state.userInfo.id, this.no).then(
        (result) => {
          if (result.body.PAY_LIST) {
            this.payRecordsList = result.body.PAY_LIST;
          } else {
            this.payRecordsList = [];
          }

          if (result.body.ONEINFO_LIST) {
            this.oneInfoList = result.body.ONEINFO_LIST.map((item) => {
              let memo = "";
              if (item.RTN_CODE === "1") {
                memo = "請洽服務中心查詢";
              } else if (item.BENE_PRIO && item.BENE_PRIO !== "0") {
                memo = "順位: " + item.BENE_PRIO;
              } else if (item.BENE_RATO && item.BENE_RATO !== "0.00") {
                memo = "比例: " + Math.abs(item.BENE_RATO) + "%";
              }
              return {
                bene_name: item.BENE_NAME,
                bene_role: item.BENE_ROLE,
                bene_type: item.BENE_TYPE,
                bank_simple_name:
                  item.BANK_SIMPLE_NAME !== "" ? item.BANK_SIMPLE_NAME : `— —`,
                acnt_no_last4:
                  item.ACNT_NO_LAST4 === "未約定" ? `— —` : item.ACNT_NO_LAST4,
                memo: memo,
              };
            });
          } else {
            this.oneInfoList = [];
          }

          this.isLoading_4 = false;
        }
      );
    },

    getPaymentMessage() {
      //查詢繳費訊息
      this.isLoading_3 = true;
      queryPaymentMessage(this.$store.state.userInfo.id, this.no).then(
        (result) => {
          if (result.body.PaymentDetail) {
            this.PaymentDetail = result.body.PaymentDetail;
          } else {
            this.PaymentDetail = [];
          }
          if (result.body.PaymentRecord) {
            this.PaymentRecord = result.body.PaymentRecord;
          } else {
            this.PaymentRecord = [];
          }
          this.isLoading_3 = false;
        }
      );
    },

    getBeneficiariesList() {
      //查詢主約受益人明細
      this.isLoading_5 = true;
      queryMainPolicyBeneficiariesInfo(
        this.$store.state.userInfo.id,
        this.no
      ).then((result) => {
        if (result.body && result.body.rider_list) {
          this.beneficiariesList = result.body.rider_list;
        } else {
          this.beneficiariesList = [];
        }
        this.isLoading_5 = false;
      });
    },
    getPerformance() {
      //查詢投資績效
      this.isLoading_6 = true;
      queryInvestPerformance(this.$store.state.userInfo.id, this.no).then(
        (result) => {
          this.showItem = result.body.showitem.interest; //近三個月現金配息
          if (result.body) {
            this.InventUrl = result.body.url || "";
            this.ILPStatementUrl = result.body.ilpstatementurl || "";
          }
          if (result.body && result.body.performance) {
            this.targetsCurr = result.body.performance.curr_c || "";
            this.investmentPerformance = result.body.performance;
          } else {
            this.targetsCurr = "";
            this.investmentPerformance = {};
          }
          if (result.body && result.body.targets) {
            this.investmentTargets = result.body.targets;
            let pattern = new RegExp("^NB+|^NJ+");
            if (pattern.test(this.prodId)) {
              this.investmentTargets.forEach((item) => {
                (item.cost = item.net_in_amt),
                  (item.remuneration = item.reward_rate);
              });
            } else {
              this.investmentTargets.forEach((item) => {
                (item.cost = item.hold_cost),
                  (item.remuneration = item.fund_roi);
              });
            }
          } else {
            this.investmentTargets = [];
          }
          if (result.body && result.body.datas) {
            this.interestDatas = result.body.datas;
          } else {
            this.interestDatas = [];
          }
          this.isLoading_6 = false;
          this.getProfit();
        }
      );
    },
    getProfit() {
      //查詢投資約定
      this.isLoading_7 = true;
      queryInvestProfit(
        this.$store.state.userInfo.id,
        this.targetId,
        this.no
      ).then((result) => {
        this.investdata = result.body;
        this.showStopSetting = result.body.showitem.TAKE_PROFIT_SETTING; //停利設定
        this.showInvestmentAgreement = result.body.showitem.INVESTMENT_SETTING; //投資約定顯示table
        if (
          result.body &&
          result.body.profitSettings &&
          result.body.profitSettings.dataList
        ) {
          this.profitSettingsKeyDate =
            result.body.profitSettings.dataList.keyDate;
          this.profitSettingsData = result.body.profitSettings.dataList.B.map(
            (item) => {
              return {
                keyDate: result.body.profitSettings.dataList.keyDate,
                FUND_CURR_NAME: item.FUND_CURR_NAME,
                PRFT_PT: item.PRFT_PT,
                QRY_YEAR: item.QRY_YEAR,
                SERIAL_NO: item.SERIAL_NO,
                DATA_KIND: item.DATA_KIND,
                FUND_C_NAME: item.FUND_C_NAME,
                PROG_ID: item.PROG_ID,
                EFT_DATE: item.EFT_DATE,
                FUND_ID: item.FUND_ID,
                INPUT_DATE: item.INPUT_DATE,
              };
            }
          );
        } else {
          this.profitSettingsKeyDate = "";
          this.profitSettingsData = [];
        }
        if (result.body && result.body.investmentSetting) {
          if (result.body.investmentSetting.record1Data0) {
            this.record1Data0KeyDate =
              result.body.investmentSetting.record1Data0.keyDate;
            this.record1Data0 = result.body.investmentSetting.record1Data0.dataList.map(
              (item) => {
                return {
                  keyDate: result.body.investmentSetting.record1Data0.keyDate,
                  FUND_ID: item.FUND_ID,
                  FUND_C_NAME: item.FUND_C_NAME,
                  FUND_CURR_NAME: item.FUND_CURR_NAME,
                  INV_RATE: item.INV_RATE,
                };
              }
            );
          }
          if (result.body.investmentSetting.record1Data1) {
            this.record1Data1KeyDate =
              result.body.investmentSetting.record1Data1.keyDate;
            this.record1Data1 = result.body.investmentSetting.record1Data1.dataList.map(
              (item) => {
                return {
                  keyDate: result.body.investmentSetting.record1Data1.keyDate,
                  FUND_ID: item.FUND_ID,
                  FUND_C_NAME: item.FUND_C_NAME,
                  FUND_CURR_NAME: item.FUND_CURR_NAME,
                  INV_RATE: item.INV_RATE,
                };
              }
            );
          }
          if (result.body.investmentSetting.record1Data2) {
            this.record1Data2KeyDate =
              result.body.investmentSetting.record1Data2.keyDate;
            this.record1Data2 = result.body.investmentSetting.record1Data2.dataList.map(
              (item) => {
                return {
                  keyDate: result.body.investmentSetting.record1Data2.keyDate,
                  FUND_ID: item.FUND_ID,
                  FUND_C_NAME: item.FUND_C_NAME,
                  FUND_CURR_NAME: item.FUND_CURR_NAME,
                  INV_RATE: item.INV_RATE,
                  ADD_RATIO: item.ADD_RATIO,
                };
              }
            );
          }
          if (result.body.investmentSetting.record1Data3) {
            this.record1Data3KeyDate =
              result.body.investmentSetting.record1Data3.keyDate;
            if (this.targetsCurr == "新台幣") {
              this.record1Data3AFT_AMT =
                result.body.investmentSetting.record1Data3.dataList[0].AFT_AMT_NT;
            } else {
              this.record1Data3AFT_AMT =
                result.body.investmentSetting.record1Data3.dataList[0].AFT_AMT;
            }
          }
          if (result.body.investmentSetting.record1Data4) {
            this.record1Data4KeyDate =
              result.body.investmentSetting.record1Data4.keyDate;
            this.record1Data4 = result.body.investmentSetting.record1Data4.dataList.map(
              (item) => {
                return {
                  keyDate: result.body.investmentSetting.record1Data4.keyDate,
                  FUND_CURR_NAME: item.FUND_CURR_NAME,
                };
              }
            );
          }
          if (result.body.investmentSetting.record1Data5) {
            this.record1Data5KeyDate =
              result.body.investmentSetting.record1Data5.keyDate;
            this.record1Data5AFT_BOU_TYPE_OPT_C =
              result.body.investmentSetting.record1Data5.dataList[0].AFT_BOU_TYPE_OPT_C;
            console.log(
              "///////////////////" + this.record1Data5AFT_BOU_TYPE_OPT_C
            );
          }
          if (result.body.investmentSetting.record1Data6) {
            this.record1Data6KeyDate =
              result.body.investmentSetting.record1Data6.keyDate;
            this.record1Data6 = result.body.investmentSetting.record1Data6.dataList.map(
              (item) => {
                return {
                  keyDate: result.body.investmentSetting.record1Data6.keyDate,
                  FUND_ID: item.FUND_ID,
                  FUND_C_NAME: item.FUND_C_NAME,
                  FUND_CURR_NAME: item.FUND_CURR_NAME,
                  INV_RATE: item.INV_RATE,
                };
              }
            );
          }
          if (result.body.investmentSetting.record1Data7) {
            this.record1Data7KeyDate =
              result.body.investmentSetting.record1Data7.keyDate;
            this.record1Data7 = result.body.investmentSetting.record1Data7.dataList.map(
              (item) => {
                return {
                  keyDate: result.body.investmentSetting.record1Data7.keyDate,
                  FUND_ID: item.FUND_ID,
                  FUND_C_NAME: item.FUND_C_NAME,
                  FUND_CURR_NAME: item.FUND_CURR_NAME,
                  INV_RATE: item.INV_RATE,
                };
              }
            );
          }
          if (result.body.investmentSetting.record1Data8) {
            this.record1Data8KeyDate =
              result.body.investmentSetting.record1Data8.keyDate;
            this.record1Data8 = result.body.investmentSetting.record1Data8.dataList.map(
              (item) => {
                return {
                  keyDate: result.body.investmentSetting.record1Data8.keyDate,
                  FUND_ID: item.FUND_ID,
                  FUND_C_NAME: item.FUND_C_NAME,
                };
              }
            );
          }
          if (result.body.investmentSetting.record1Data9) {
            this.record1Data9KeyDate =
              result.body.investmentSetting.record1Data9.keyDate;
            this.record1Data9 = result.body.investmentSetting.record1Data9.dataList.map(
              (item) => {
                return {
                  keyDate: result.body.investmentSetting.record1Data9.keyDate,
                  FUND_ID: item.FUND_ID,
                  FUND_C_NAME: item.FUND_C_NAME,
                  FUND_CURR_NAME: item.FUND_CURR_NAME,
                  KIND_NAME: item.KIND_NAME
                };
              }
            );
          }
          if (result.body.investmentSetting.record1Data10) {
            this.record1Data10KeyDate =
              result.body.investmentSetting.record1Data10.keyDate;
            this.record1Data10 = result.body.investmentSetting.record1Data10.dataList.map(
              (item) => {
                return {
                  keyDate: result.body.investmentSetting.record1Data10.keyDate,
                  FUND_ID: item.FUND_ID,
                  FUND_C_NAME: item.FUND_C_NAME,
                  FUND_CURR_NAME: item.FUND_CURR_NAME,
                  INV_RATE: item.INV_RATE,
                };
              }
            );
          }
        } else {
          this.record1Data1KeyDate = "";
          this.record1Data1 = [];
          this.record1Data2KeyDate = "";
          this.record1Data2 = [];
          this.record1Data3KeyDate = "";
          this.record1Data3AFT_AMT = [];
          this.record1Data4KeyDate = "";
          this.record1Data4 = [];
          this.record1Data5KeyDate = "";
          this.record1Data5AFT_BOU_TYPE_OPT_C = [];
          this.record1Data6KeyDate = "";
          this.record1Data6 = [];
          this.record1Data7KeyDate = "";
          this.record1Data7 = [];
          this.record1Data8KeyDate = "";
          this.record1Data8 = [];
          this.record1Data9KeyDate = "";
          this.record1Data9 = [];
          this.record1Data10KeyDate = "";
          this.record1Data10 = [];
        }
        this.isLoading_7 = false;
      });
    },
    createPDF() {
      if (this.printButtonDisabled) {
        return;
      }

      let promise = this.investdata.investmentSetting;

      let reqObj = {
        data: {
          POLICY_NO: this.mainPolicyInfo.POLICY_NO,
          AGENT_ID: this.$store.state.userInfo.id,
          PROD_NAME: this.PDFName,
          ISSUE_DATE: this.mainPolicyInfo.ISSUE_DATE,
          APC_NM: this.mainPolicyInfo.APC_NM,
          INSD_NM: this.mainPolicyInfo.INSD_NM,
          FACE_AMT: this.investmentPerformance.face_amt,
          PAY_FREQ_NM: this.investmentPerformance.pay_freq_nm,
          PAY_TIMES: this.investmentPerformance.pay_times,
          RD_PREM: this.investmentPerformance.rd_prem,
          ACNT_NO_TRN_ORI: this.investmentPerformance.acnt_no_trn_ori,
          POL_ACC_VAL: this.investmentPerformance.pol_acc_val,
          BOU_DIV_L: this.investmentPerformance.bou_div_l,
          SUM_PAY_PREM: this.investmentPerformance.sum_pay_prem,
          SUM_PREM_FEE: this.investmentPerformance.sum_prem_fee,
          SUM_TOT_FEE: this.investmentPerformance.sum_tot_fee,
          CURR_C: this.investmentPerformance.curr_c,
          ReturnOfInvestment: this.investmentPerformance.returnofinvestment,
          ReturnOfPremium: this.investmentPerformance.returnofpremium,
          InvestProfit: this.investmentPerformance.investprofit,
          ANTY_PAY_KIND: this.mainPolicyInfo.ANTY_PAY_KIND, //保單基本資料-年金給付方式
          ANTY_PAY_KIND_CH: this.mainPolicyInfo.ANTY_PAY_KIND_CH, //保單基本資料-年金給付方式
          CURR_NM: this.mainPolicyInfo.CURR_NM, //保單基本資料-保單幣別
          cryAmtWithoutFee: this.investmentPerformance.cryamtwithoutfee, //保單績效-保戶累計提領金額(B)
          dngrPolInd: this.investmentPerformance.dngrpolind, //判斷為何種投資保單
          SUM_RISK_PREM: this.investmentPerformance.sum_risk_prem,
          showItem: this.showItem,
          showStopSetting: this.showStopSetting,
          showInvestmentAgreement: this.showInvestmentAgreement,
          record1Data0: promise.record1Data0 || {},
          record1Data1: promise.record1Data1 || {},
          record1Data2: promise.record1Data2 || {},
          record1Data3: promise.record1Data3 || {},
          record1Data4: promise.record1Data4 || {},
          record1Data5: promise.record1Data5 || {},
          record1Data6: promise.record1Data6 || {},
          record1Data7: promise.record1Data7 || {},
          record1Data8: promise.record1Data8 || {},
          record1Data9: promise.record1Data9 || {},
          record1Data10: promise.record1Data10 || {},
          investment_targets: {
            //投資績效-持有標的
            dataList: this.investmentTargets.map((item) => {
              return {
                FUND_ID: item.fund_id, // 持有標的明細 標的代碼
                FUND_C_NAME: item.fund_c_name, // 持有標的明細 標的名稱
                FUND_CLASS: item.fund_class, // 持有標的明細 標的型態
                FUND_CURR_NAME: item.curr_c, //  計價幣別
                HOLD_UNIT: item.hold_unit, //  持有單位數
                BID_PRICE: item.bid_price ? item.bid_price.toString() : "", // 淨值
                BID_DATE: item.bid_date, // 淨值(日期)
                EXCH_RATE: item.exch_rate ? item.exch_rate.toString() : "", // 匯率
                EXCH_RATE_DATE: item.exch_rate_date, // 匯率(日期)
                HOLD_VAL_F: item.hold_val_f, // 市值(保單幣別)
                FUND_CURR: this.mainPolicyInfo.FUND_CURR, // 市值(保單幣別)
                HOLD_VAL_L: item.hold_val_l, // 保單幣別市值
                NET_IN_AMT: item.net_in_amt, // 持有成本(保單幣別)
                HOLD_COST: item.hold_cost, // 持有成本(保單幣別)
                REWARD_MNY: item.reward_mny, //  損益金額
                FUND_ROI: item.fund_roi, // 持有標的明細 標的報酬率
                REWARD_RATE: item.reward_rate, // 持有標的明細 標的報酬率
                PROD_ID: this.prodId,
              };
            }),
          },
          interest_data_3month: {
            dataList: this.interestDatas.map((item) => {
              return {
                BOU_DATE: item.bou_date,
                RMT_STS_DATE: item.rmt_sts_date,
                SUM_BOU_DIV_L: item.sum_bou_div_l,
                REAL_BOU_KIND: item.real_bou_kind,
                BOU_STS: item.bou_sts,
              };
            }),
          },
          profit_setting: {
            //停利設定
            keyDate:
              this.investdata.profitSettings &&
              this.investdata.profitSettings.dataList &&
              this.investdata.profitSettings.dataList.keyDate,
            dataList:
              this.investdata.profitSettings &&
              this.investdata.profitSettings.dataList &&
              this.investdata.profitSettings.dataList.B &&
              this.investdata.profitSettings.dataList.B.map((item) => {
                return {
                  FUND_ID: item.FUND_ID,
                  FUND_CURR_NAME: item.FUND_CURR_NAME,
                  PRFT_PT: item.PRFT_PT,
                  FUND_C_NAME: item.FUND_C_NAME,
                };
              }),
          },
        },
      };

      this.printButtonDisabled = true;
      getInvestPDF(this.$store.state.userInfo.id, reqObj).then((result) => {
        this.printButtonDisabled = false;
        let file = new Blob([result], { type: "application/pdf" });
        let name = "投資型保單.pdf";
        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(file, name);
        } else {
          let newWindow = window.open(
            "/crm/assets/common/ajax-loader.gif",
            this.mainPolicyInfo.POLICY_NO + name
          );
          setTimeout(function() {
            newWindow.location = URL.createObjectURL(file);
          }, 1000);
        }
      });
    },
    //取得外溢保單資訊
    getSpilloverPolicy() {
      this.isLoading_8 = true;
      this.is_show_spilloverPolicy = false;
      this.is_show_spilloverPolicy_under18 = false;
      this.is_show_spilloverPolicy_under21 = false;
      getSpilloverPolicyForBnk(this.$store.state.userInfo.id, this.no).then(
        (result) => {
          this.isLoading_8 = false;
          if (result.header && result.header.status == "200") {
            this.spilloverPolicyList = result.data || [];
            this.spilloverPolicyList.forEach((item) => {
              if (item.is_spillover_prod == "Y") {
                //只要有一筆資料是外溢保單，就要顯示外溢保單區塊和標語
                this.is_show_spilloverPolicy = true;
              }
              if (item.is_show_under18) {
                //只要有一筆資料符合顯示條件，就顯示客戶小於18歲以下的標語
                this.is_show_spilloverPolicy_under18 = true;
              }
              if (item.is_show_under21) {
                //只要有一筆資料符合顯示條件，就顯示客戶小於21歲以下的標語
                this.is_show_spilloverPolicy_under21 = true;
              }
            });
          } else {
            this.spilloverPolicyList = [];
          }
        }
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.div-spillover-policy {
  padding-bottom: 1%;
}
.span-prod-hint-block {
  font-size: 20px;
}
.span-prod-name-block {
  font-size: 20px;
  font-weight: 600;
}
.span-insd-name-block {
  font-size: 18px;
}
.span-spillover-start-term-date {
  font-size: 18px;
  padding-left: 5%;
}
.product-hyper-link {
  text-decoration: none;
}
.loading-block {
  background-image: url(/crm/assets/common/ajax-loader.gif);
  background-repeat: no-repeat;
  opacity: 0.8;
}
.loading-text {
  padding-left: 27px;
}
.hint-text {
  font-weight: 600;
  color: red;
}
</style>
